import { DropdownMenuTrigger } from '@radix-ui/react-dropdown-menu';
import { buttonVariants } from '@design-system/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@design-system/dropdown-menu';
import { cn } from '@design-system/helpers';
import { EllipsisVerticalIcon } from 'lucide-react';

const SettingsHeaderActions = () => {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={cn(
            buttonVariants({ size: 'iconSm', variant: 'primaryOutline' }),
            'border-primary-200'
          )}
        >
          <EllipsisVerticalIcon />
        </DropdownMenuTrigger>

        <DropdownMenuContent align='end'>
          <DropdownMenuItem>Masquerading</DropdownMenuItem>

          <DropdownMenuItem className='text-red-500'>
            Deactivate Account
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default SettingsHeaderActions;
